import React from 'react';
import type { ReactNode } from 'react';
import MainContent from './MainContent';
import SkipNavAnchor from './SkipNavAnchor';

export interface SkipNavProps {
  children: ReactNode;
}

/**
 * The SkipNav Component based on The USWDS SkipNav component ([scss](https://github.com/uswds/uswds/blob/master/src/stylesheets/components/_skipnav.scss),
 * [javascript](https://github.com/uswds/uswds/blob/master/src/js/components/skipnav.js))
 *
 *  > This component is not specifically documented as a component on the docs but is referenced
 *  in the [Header](https://designsystem.digital.gov/components/header/) and [Banner](https://designsystem.digital.gov/components/banner/).
 *
 * This root component is now optional. The context provider has been removed and `<SkipNav.Anchor>`
 * and `<SkipNav.MainContent>` can be used independently.
 */
const SkipNav = ({ children }: SkipNavProps): JSX.Element => {
  return <>{children}</>;
};

SkipNav.MainContent = MainContent;
SkipNav.Anchor = SkipNavAnchor;

export default SkipNav;
